import { useEffect, useMemo, useRef, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import styles from '../POWorkflowManagement/po_workflow_management.module.css';
import { getSystemPoWorkflowDashboard } from './functions/get_system_po_workflow_dashboard.function';
import * as echarts from 'echarts';

// Reuse existing dashboard UI by importing the same CSS module and charts lib,
// but keep the component separate so vendor module remains untouched.

export const SystemPOWorkflowDashboardTab = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const amountTreeChartRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const data = await getSystemPoWorkflowDashboard();
        if (!cancelled) {
          setInvoices(Array.isArray(data?.invoices) ? data.invoices : []);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const totalAmount = useMemo(
    () => invoices.reduce((sum, r) => sum + Number(r?.invoice_amount || 0), 0),
    [invoices]
  );

  useEffect(() => {
    if (!amountTreeChartRef.current) {
      return;
    }
    const chart = echarts.init(amountTreeChartRef.current);
    chart.setOption({
      title: { text: 'Invoice Amount Breakdown', left: 'center' },
      tooltip: { trigger: 'item' },
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          data: [
            { name: 'Total', value: totalAmount },
            { name: 'Count', value: invoices.length },
          ],
        },
      ],
    });
    return () => chart.dispose();
  }, [invoices, totalAmount]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <div className={styles['charts-row']}>
        <div className={styles['pie-chart-container']}>
          <div ref={amountTreeChartRef} style={{ height: 360, width: '100%' }} />
        </div>
      </div>
    </Box>
  );
};
